import { LoaderCircleIcon } from "lucide-react";

export const Spinner = () => {
  return <LoaderCircleIcon className="animate-spin mx-auto" size={28} />;
};
